import React, { Component } from 'react';
import Link from '../common/TrackedLink';
import LazyLoad from 'react-lazyload';

class ProductCard extends Component {
	constructor(props) {
		super(props);
		this.state = ({
			checked: false
		});
	}

	addToCompare(event) {
		this.props.addToCompare(event);
		if (this.state.checked === true) {
			this.setState({
				checked: false
			});
		} else {
			this.setState({
				checked: true
			});
		}
		global.dataLayer.push({
			event: 'Product Tile',
			eventCategory: 'Product Tiles',
			eventAction: 'Compare',
			eventLabel: `${this.props.product.name} - Model ${this.props.product.modelNumber}`
		});
	}

	handleClickCompare() {
		this.props.clickCompare();
	}

	render() {
		let productTile;
		if (this.props.product.tile) {
			productTile = (
				<Link
					className="results-callout"
					to={ this.props.product.manualLink }
					trackEventAction={ this.props.product.name }
				>
					<div>
						<h3 className="title">
							{ this.props.product.name }
						</h3>
						<p>{ this.props.product.modelNumber }</p>
						<span className="arrow-link">
							{ this.props.product.image }
						</span>
					</div>
				</Link>
			);
		} else {
			productTile = (
				<div className="product-info">
					<Link
						to={ `/product/${this.props.product.modelNumber}` }
						trackEvent="Product Tile"
						trackEventCategory="Product Tiles"
						trackEventAction="All Product Page Tiles"
						trackEventLabel={ `${this.props.product.name} - Model ${this.props.product.modelNumber}` }
					>
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ this.props.product.image }
									alt={ `Model ${this.props.product.modelNumber}` }
								/>
							</LazyLoad>
							{
								this.props.product.hoverImage !== undefined ?
								(
									<LazyLoad once={ true } offset={ 200 }>
										<img
											src={ this.props.product.hoverImage }
											alt={ `Model ${this.props.product.modelNumber}` }
										/>
									</LazyLoad>
								) : null
							}
						</div>
						<h3 className="name">
							{ this.props.product.name }
							<span className="assistive-text"> &ndash;</span>
							<span className="model"> Model { this.props.product.modelNumber }</span>
						</h3>
						<p className="price">
							{ this.props.product.priceBucket }
						</p>
					</Link>
					<div className="compare">
						<input
							type="checkbox"
							id={ `compare${this.props.product.modelNumber}` }
							value={ this.props.product.modelNumber }
							checked={ this.props.product.checked }
							onChange={ () => this.addToCompare(this.props.product.modelNumber) }
						/>
						<label
							htmlFor={ `compare${this.props.product.modelNumber}` }
							className={ this.state.checked ? 'assistive-text' : 'active' }
						>
							Check to Compare
						</label>
						<a
							onClick={ () => this.handleClickCompare() }
							className={ this.state.checked ? 'active' : 'hide' }
						>
							Compare
						</a>
					</div>
				</div>
			);
		}

		let stack;
		if(this.props.product.bestOfBest) {
			stack = (
				<span className="card-flag text-white">
					<span className="card-flag-text"> Best Seller</span>
					 <svg xmlns="http://www.w3.org/2000/svg" width="145" height="34" viewBox="0 0 145 34"
						  className="text-secondary-alt">
						<path className="cls-1" d="M0,0V34H133L145,0"/>
					  </svg>
				</span>
			);
		}

		return (
			<li className="product-detail col sm-4">
				{ stack }
				{ productTile }
			</li>
		);
	}
};

export default ProductCard;


// WEBPACK FOOTER //
// ./src/pages/productSearch/ProductCard.js